var React = require('react');

function News (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"#news .cls-1{fill:#6d6d6d;}")),React.createElement("path",{"className":"cls-1","d":"M20.3,35a4,4,0,0,1-.3,1.5H39.3A1.54,1.54,0,0,0,40.8,35V16.9H20.3Zm18.5-1.8H34.4V30.9h4.4ZM22.2,19.8H38.7V24H22.2Zm0,6.4H38.7v2.3H22.2Zm0,4.7H31v2.3H22.2Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M27.3,0A27.3,27.3,0,1,0,54.6,27.3,27.27,27.27,0,0,0,27.3,0M43.4,35.6a4.12,4.12,0,0,1-4.1,4.1H15.4a4.12,4.12,0,0,1-4.1-4.1v-15a1.32,1.32,0,0,1,1.3-1.3h2.7v2.6H13.9V35.6a1.54,1.54,0,0,0,1.5,1.5h.8a1.54,1.54,0,0,0,1.5-1.5V16.1A1.32,1.32,0,0,1,19,14.8H42.1a1.32,1.32,0,0,1,1.3,1.3V35.6Z","key":2})]);
}

News.defaultProps = {"id":"news","data-name":"Layer 1","viewBox":"0 0 54.6 54.6"};

module.exports = News;

News.default = News;
